const path = require('path')
const pack = require('../package.json')
const argvs = process.argv.slice(2)

function resolve (dir) {
  return path.join(__dirname, '..', dir)
}

function getParams (key) {
  let item = argvs.find(item => item.split('=')[0] === key)
  return item ? item.split('=') : []
}

function getModuleAlias () {
  let alias = {}
  importModules.forEach(({ name }) => {
    alias[`@${name}`] = resolve(`src/${name}`)
  })
  return alias
}

class MultiModule {
  constructor (name, opts) {
    let datetime = Date.now()
    Object.assign(this, {
      name,
      assetsSubDirectory: 'static',
      assetsPublicPath: '/',
      port: 8080,
      secondPath: opts.secondPath || '',
      host: '0.0.0.0',
      proxyTable: null,
      entry: {
        app: ['babel-polyfill', `./src/${name}/main.js`]
      },
      alias: resolve(`src/${name}`),
      index: path.resolve(__dirname, `../dist/${name}/index.html`),
      favicon: path.resolve(__dirname, `../src/${name}/assets/favicon.ico`),
      title: opts.title || '后台管理',
      assetsRoot: path.resolve(__dirname, `../dist/${name}/`),
      pubdate: `${name}_v${pack.version}_${datetime}`,
      publics: [name].concat(opts.statics || []),
      deployConfig: null
    }, opts)
  }
}

function getModuleProcess (name) {
  let mItem = importModules.find(item => item.name === name)
  return mItem || importModules[0]
}

function proxyHandle (proxyReq, req, res, options) {
  let origin = `${options.target.protocol}//${options.target.hostname}`
  proxyReq.setHeader('origin', origin)
  proxyReq.setHeader('referer', origin)
}

function onProxyReq (proxyReq, req, res, options) {
  proxyHandle(proxyReq, req, res, options)
}

function onProxyReqWs (proxyReq, req, socket, options, head) {
  proxyHandle(proxyReq, req, socket, options)
}

function getProxyConfig (target, options) {
  return Object.assign({
    target,
    secure: false,
    changeOrigin: true,
    ws: false,
    cookieDomainRewrite: { '*': '' },
    cookiePathRewrite: { '*': '/' },
    onProxyReq,
    onProxyReqWs
  }, options)
}

const PROXY_DOMAIN_DEFAULT = 'http://www.baidu.com'

// 多模块独立配置
var importModules = [
  new MultiModule('zzcbpmDashboard', {
    port: 8096,
    statics: ['static4'],
    secondPath: '/zzcbpm/admin', //二级目录，部署时候如果部署到二级目录就要配置这个
    title: '业务流程管理',
    proxyTable: {
      // '/api': getProxyConfig('http://test.zzc.wufen21.com/zzcbpm')
      '/api': getProxyConfig('https://bpm.yf-gz.cn')
    }
  }),
  new MultiModule('warehouse', {
    port: 8097,
    statics: [],
    secondPath: '/psi', //二级目录，部署时候如果部署到二级目录就要配置这个
    title: '业务流程管理',
    proxyTable: {
    '/investmenttea/api': getProxyConfig('http://test.zzc.wufen21.com'),
    '/api': getProxyConfig('http://test.zzc.wufen21.com/zzcbpm'),
      // '/api': getProxyConfig('https://bpm.yf-gz.cn')
    }
  }),
  new MultiModule('digitalHuman', {
    port: 8098,
    statics: [],
    // secondPath: '/digitalHuman', //二级目录，部署时候如果部署到二级目录就要配置这个
    title: 'AI数字人',
    // favicon: '',
    proxyTable: {
      // 测试服
      '/aichat/api': getProxyConfig('http://test.zzc.wufen21.com/digitalHuman'),
      '/api': getProxyConfig('http://test.zzc.wufen21.com/digitalHuman'),

      //新版正式服
      // '/aichat/api': getProxyConfig('https://aibeings.yf-gz.cn'),
      // '/api': getProxyConfig('https://aibeings.yf-gz.cn'),
    }
  }),
]
var lifecycleEvents = String(process.env.npm_lifecycle_event).split(':')
var moduleName = getParams('name')[1] || lifecycleEvents[1]
console.log('moduleName',moduleName);
const multiConfig = {
  modules: importModules,
  moduleAlias: getModuleAlias(),
  process: getModuleProcess(moduleName),
  process2: (moduleName2) => {
    return getModuleProcess(moduleName2)
  }
}

module.exports = multiConfig



//////////////////
// WEBPACK FOOTER
// ./config/multi.conf.js
// module id = vltW
// module chunks = 17